import { render } from "./SelectInputPagoState.vue?vue&type=template&id=6d84bf6a"
import script from "./SelectInputPagoState.vue?vue&type=script&lang=js"
export * from "./SelectInputPagoState.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__